<template>
  <div
    :style="{
      height: `${pagesHeight}px`,
      overflow: 'hidden'
    }"
  >
    <div
      :style="{
        width: '1920px',
        height: bodyHeight || '1080px',
        'transformOrigin':'left top',
        'transform':`scale(${scalseNum})`,
        '-webkit-transform':`scale(${scalseNum})`,
        '-moz-transform':`scale(${scalseNum})`,
        '-o-transform':`scale(${scalseNum})`,
        '-ms-transform':`scale(${scalseNum})`
      }"
    >
      <div id="FinancialMediaIntelligent">
        <div class="hd"></div>
        <div class="content-media-wrap">
          <div class="floor-1">
            <div class="floor-1-1">
              <c-block-box title="设备总体情况" class="full-width-block">
                <div class="gen-wrap">
                  <div class="gen-hd">
                    <div class="hd-lists-wrap">
                      <div class="lists-item margin-bottom-1rem">
                        <span class="name">设备总量:</span>
                        <div class="counts-wrap">
                          <span class="count" v-for="(item,index) in '124853'" :key="index">{{ item }}</span>
                        </div>
                      </div>
                      <div class="lists-item">
                        <span class="name">在线总量:</span>
                        <div class="counts-wrap">
                          <span class="count" v-for="(item,index) in '32021'" :key="index">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="lists-wrap-general">
                    <div class="lists-hd-title">
                      <span class="title-24"></span>
                      <span>影响人数</span>
                      <span>设备量</span>
                      <span>在线设备</span>
                      <span>在线率</span>
                    </div>
                    <GeneralConditionEquipmentItemWrap
                      v-for="(item,index) in GeneralConditionEquipmentItemWrapLists"
                      :key="item.title"
                      :title="item.title"
                      :lists="item.lists"
                      :class="[`GeneralCondition__title-${index+1}`]"
                    ></GeneralConditionEquipmentItemWrap>
                  </div>
                </div>
              </c-block-box>
            </div>
            <div class="floor-1-2">
              <div class="flash-point">
                <span
                  v-for="(item,index) in 100"
                  :key="item"
                  class="star"
                  :class="`star`+item"
                  :style="{
                    'background-image': `url(//img2.coocaa.com/images/stars/star${getRandomInt(1,5)}.png)`,
                    'animation-delay': `${Math.random() * 1.2}s`,
                    ...getStartsPosition(index)
                  }"
                ></span>
                <!-- <span class="star star2"></span>
                <span class="star star3"></span>
                <span class="star star4"></span>
                <span class="star star5"></span> -->
              </div>
              <DomeEchartWrap ref="baoan"></DomeEchartWrap>
              <div class="time">
                <p>{{ time }}更新</p>
              </div>
              <div class="floor-1-2-left">
                <div class="border-linear-parent">
                  <p class="title">实时活跃</p>
                  <div class="map-left-list">
                    <div class="item" v-for="item in mapRightLists" :key="item.name">
                      <span class="name">{{ item.name }}</span>
                      <span class="count">{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="floor-1-2-right">
                <div class="border-linear-parent">
                  <p class="title">当日播放</p>
                  <div class="map-right-list">
                    <div class="item" v-for="item in mapLeftLists" :key="item.name">
                      <span class="name">{{ item.name }}</span>
                      <span class="count">{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="floor-1-2-bot">
                <div class="map-bot-list">
                  <div
                    class="item border-color-linear-parent"
                    v-for="(item,index) in mapBotLists"
                    :key="item.name"
                  >
                    <div class="border-linear-children ">
                      <span class="icon" :class="[`item-map-bot-${index+1}`]"></span>
                      <span class="name">{{ item.name }}</span>
                      <span class="count">{{ item.value }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <video
                loop
                muted
                autoplay
              >
                <source src="~@/assets/images/rong-nan.mp4" type="video/mp4" />
                您的浏览器不支持 video 标签。
              </video> -->
            </div>
            <div class="floor-1-3">
              <c-block-box title="近30日内容活跃情况">
                <div class="play-content30-wrap">
                  <PlayContentRankingWrap :lists="PlayContentRankingWrapLists"></PlayContentRankingWrap>
                  <DistributionPlaybackTimesEachArea></DistributionPlaybackTimesEachArea>
                </div>
              </c-block-box>
            </div>
          </div>
          <div class="floor-2">
            <div class="floor-2-1">
              <c-block-box title="各区设备分布">
                <div class="floor-2-box-wrap">
                  <EquipmentDistributionArea :lists="EquipmentDistributionAreaLists"></EquipmentDistributionArea>
                </div>
              </c-block-box>
            </div>
            <div class="floor-2-2">
              <c-block-box title="近7日设备活跃Top10">
                <div style="height:14.5rem">
                  <el-scrollbar style="height:100%" class="no-scrollbar-y">
                    <DeviceActiveTopTen></DeviceActiveTopTen>
                  </el-scrollbar>
                </div>
              </c-block-box>
            </div>
            <div class="floor-2-3">
              <c-block-box title="近7日融媒影响力分布">
                <div>
                  <DistributionFinancialMediaInfluence></DistributionFinancialMediaInfluence>
                </div>
              </c-block-box>
            </div>
            <div class="floor-2-4">
              <c-block-box title="近7日社区屏互动内容情况">
                <div class>
                  <UseCommunityInteractiveScreen></UseCommunityInteractiveScreen>
                </div>
              </c-block-box>
            </div>
          </div>
        </div>
        <!-- <DomeEchartWrap ref="world-map"></DomeEchartWrap> -->
      </div>
    </div>
  </div>
</template>

<script>
import GeneralConditionEquipmentItemWrap from '@/components/FinancialMediaIntelligent/GeneralConditionEquipmentItemWrap'
import EquipmentDistributionArea from '@/components/FinancialMediaIntelligent/EquipmentDistributionArea'
import DeviceActiveTopTen from '@/components/FinancialMediaIntelligent/DeviceActiveTopTen'
import DistributionFinancialMediaInfluence from '@/components/FinancialMediaIntelligent/DistributionFinancialMediaInfluence'
import UseCommunityInteractiveScreen from '@/components/FinancialMediaIntelligent/UseCommunityInteractiveScreen'
import PlayContentRankingWrap from '@/components/FinancialMediaIntelligent/PlayContentRankingWrap'
import DistributionPlaybackTimesEachArea from '@/components/FinancialMediaIntelligent/DistributionPlaybackTimesEachArea'
import nanshan from '@/components/echarts/map/json/nanshan-map.json'
import nanshanjiedao from '@/components/echarts/map/json/nanshan-jiedao.json'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
export default {
  mixins: [ccMapMixin, common, scalseNum],
  name: 'FinancialMediaIntelligent',
  components: { DomeEchartWrap, DistributionPlaybackTimesEachArea, PlayContentRankingWrap, UseCommunityInteractiveScreen, GeneralConditionEquipmentItemWrap, EquipmentDistributionArea, DeviceActiveTopTen, DistributionFinancialMediaInfluence },
  props: {},
  data () {
    return {
      points: [
        {
          'left': 463,
          'top': 75
        },
        {
          'left': 456,
          'top': 105
        },
        {
          'left': 453,
          'top': 139
        },
        {
          'left': 453,
          'top': 58
        },
        {
          'left': 441,
          'top': 161
        },
        {
          'left': 438,
          'top': 226
        },
        {
          'left': 406,
          'top': 281
        },
        {
          'left': 387,
          'top': 317
        },
        {
          'left': 377,
          'top': 323
        },
        {
          'left': 375,
          'top': 307
        },
        {
          'left': 357,
          'top': 339
        },
        {
          'left': 337,
          'top': 370
        },
        {
          'left': 323,
          'top': 398
        },
        {
          'left': 360,
          'top': 308
        },
        {
          'left': 376,
          'top': 286
        },
        {
          'left': 376,
          'top': 389
        },
        {
          'left': 349,
          'top': 403
        },
        {
          'left': 382,
          'top': 364
        },
        {
          'left': 389,
          'top': 358
        },
        {
          'left': 379,
          'top': 419
        },
        {
          'left': 364,
          'top': 450
        },
        {
          'left': 358,
          'top': 466
        },
        {
          'left': 360,
          'top': 435
        },
        {
          'left': 414,
          'top': 396
        },
        {
          'left': 440,
          'top': 371
        },
        {
          'left': 490,
          'top': 310
        },
        {
          'left': 515,
          'top': 270
        },
        {
          'left': 525,
          'top': 248
        },
        {
          'left': 502,
          'top': 197
        },
        {
          'left': 488,
          'top': 209
        },
        {
          'left': 522,
          'top': 227
        },
        {
          'left': 560,
          'top': 180
        },
        {
          'left': 552,
          'top': 131
        },
        {
          'left': 549,
          'top': 113
        },
        {
          'left': 523,
          'top': 149
        },
        {
          'left': 510,
          'top': 176
        },
        {
          'left': 485,
          'top': 186
        },
        {
          'left': 461,
          'top': 207
        },
        {
          'left': 433,
          'top': 195
        },
        {
          'left': 436,
          'top': 174
        },
        {
          'left': 442,
          'top': 101
        },
        {
          'left': 448,
          'top': 68
        },
        {
          'left': 461,
          'top': 38
        },
        {
          'left': 485,
          'top': 70
        },
        {
          'left': 501,
          'top': 98
        },
        {
          'left': 487,
          'top': 122
        },
        {
          'left': 507,
          'top': 81
        },
        {
          'left': 519,
          'top': 72
        },
        {
          'left': 521,
          'top': 126
        },
        {
          'left': 541,
          'top': 162
        },
        {
          'left': 529,
          'top': 214
        },
        {
          'left': 542,
          'top': 185
        },
        {
          'left': 580,
          'top': 156
        },
        {
          'left': 547,
          'top': 183
        },
        {
          'left': 532,
          'top': 196
        },
        {
          'left': 439,
          'top': 277
        },
        {
          'left': 435,
          'top': 305
        },
        {
          'left': 435,
          'top': 344
        },
        {
          'left': 450,
          'top': 277
        },
        {
          'left': 422,
          'top': 348
        },
        {
          'left': 445,
          'top': 269
        },
        {
          'left': 458,
          'top': 259
        },
        {
          'left': 495,
          'top': 227
        },
        {
          'left': 530,
          'top': 203
        },
        {
          'left': 431,
          'top': 268
        },
        {
          'left': 441,
          'top': 343
        },
        {
          'left': 423,
          'top': 350
        },
        {
          'left': 398,
          'top': 338
        },
        {
          'left': 382,
          'top': 355
        },
        {
          'left': 436,
          'top': 339
        },
        {
          'left': 426,
          'top': 327
        },
        {
          'left': 453,
          'top': 323
        },
        {
          'left': 432,
          'top': 265
        },
        {
          'left': 452,
          'top': 264
        },
        {
          'left': 466,
          'top': 267
        },
        {
          'left': 444,
          'top': 328
        },
        {
          'left': 429,
          'top': 328
        },
        {
          'left': 450,
          'top': 351
        },
        {
          'left': 459,
          'top': 330
        },
        {
          'left': 341,
          'top': 396
        },
        {
          'left': 330,
          'top': 411
        },
        {
          'left': 364,
          'top': 376
        },
        {
          'left': 398,
          'top': 346
        },
        {
          'left': 409,
          'top': 316
        },
        {
          'left': 388,
          'top': 289
        },
        {
          'left': 390,
          'top': 271
        },
        {
          'left': 397,
          'top': 243
        },
        {
          'left': 402,
          'top': 220
        },
        {
          'left': 451,
          'top': 260
        },
        {
          'left': 452,
          'top': 354
        },
        {
          'left': 394,
          'top': 343
        },
        {
          'left': 509,
          'top': 315
        },
        {
          'left': 478,
          'top': 292
        },
        {
          'left': 484,
          'top': 266
        },
        {
          'left': 503,
          'top': 259
        },
        {
          'left': 356,
          'top': 283
        },
        {
          'left': 317,
          'top': 345
        },
        {
          'left': 423,
          'top': 137
        },
        {
          'left': 432,
          'top': 63
        },
        {
          'left': 483,
          'top': 237
        }
      ],
      GeneralConditionEquipmentItemWrapLists: [
        {
          title: '户外大屏',
          lists: [
            {
              name: '影响人数',
              value: '90W'
            },
            {
              name: '设备量',
              value: 9
            },
            {
              name: '在线设备',
              value: 9
            },
            {
              name: '在线率',
              value: '100%'
            }
          ]
        },
        {
          title: '社区屏',
          lists: [
            {
              name: '影响人数',
              value: '40W'
            },
            {
              name: '设备量',
              value: 399
            },
            {
              name: '在线设备',
              value: 267
            },
            {
              name: '在线率',
              value: '67%'
            }
          ]
        },
        {
          title: '家用屏',
          lists: [
            {
              name: '影响人数',
              value: '37.2W'
            },
            {
              name: '设备量',
              value: '12.4W'
            },
            {
              name: '在线设备',
              value: '3.1W'
            },
            {
              name: '在线率',
              value: '25%'
            }
          ]
        },
        {
          title: '灯杆屏',
          lists: [
            {
              name: '影响人数',
              value: '60W'
            },
            {
              name: '设备量',
              value: 287
            },
            {
              name: '在线设备',
              value: 207
            },
            {
              name: '在线率',
              value: '72%'
            }
          ]
        },
        {
          title: '党建屏',
          lists: [
            {
              name: '影响人数',
              value: '2.5W'
            },
            {
              name: '设备量',
              value: 30
            },
            {
              name: '在线设备',
              value: 30
            },
            {
              name: '在线率',
              value: '100%'
            }
          ]
        }
      ],
      PlayContentRankingWrapLists: [
        {
          name: '2022年北京冬奥会开幕式',
          value: 748292
        },
        {
          name: '开心锤锤',
          value: 747040
        },
        {
          name: '小品一家人',
          value: 259644
        },
        {
          name: '雪中悍刀行',
          value: 236657
        },
        {
          name: '宝贝赳赳 第三季',
          value: 235647
        },
        {
          name: '宝宝巴士儿歌',
          value: 192774
        },
        {
          name: '开端',
          value: 183979
        },
        {
          name: '2022年北京冬奥会开幕式回放（集锦）',
          value: 182922
        },
        {
          name: '小猪佩奇全集',
          value: 166240
        },
        {
          name: '王牌部队',
          value: 155450
        }

      ],
      EquipmentDistributionAreaLists: [
        {
          name: '南山街道',
          bs: '10/10',
          use: '10/10'
        },
        {
          name: '西丽街道',
          bs: '8/9',
          use: '8/8'
        },
        {
          name: '蛇口街道',
          bs: '8/9',
          use: '8/8'
        },
        {
          name: '南头街道',
          bs: '7/9',
          use: '7/7'
        },
        {
          name: '粤海街道',
          bs: '8/9',
          use: '8/8'
        },
        {
          name: '沙河街道',
          bs: '7/9',
          use: '7/7'
        },
        {
          name: '招商街道',
          bs: '7/8',
          use: '7/7'
        },
        {
          name: '桃源街道',
          bs: '8/9',
          use: '8/8'
        }
        // {
        //   name: '松岗街道',
        //   bs: '7/8  88%',
        //   use: '7/7 100%'
        // },
        // {
        //   name: '燕罗街道',
        //   bs: '5/9  56%',
        //   use: '5/5 100%'
        // }
      ],
      baoanMapOptions: {
        // title是标题，根据需求是否需要，不需要直接false，需要的话自己看api配置项；
        title: {
          show: false
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            DataView: { readonly: false }
          }
        },
        tooltip: {
          trigger: 'item',
          // formatter: "名称:{a}<br />坐标:{c}"
          formatter: function (params) {
            // console.log(params)
            var res = '名称:' + params + '<br/>'
            return res
          }

        },
        geo: {
          map: 'mapData',
          zoom: 1.1,
          center: [113.940999, 22.544656],
          label: {
            show: true, //
            // areaColor: 'rgba(40, 53, 184, 1)',
            borderColor: '#111',
            textStyle: { color: 'rgba(255, 255, 255, 0.8)' }
          },
          itemStyle: {
            show: false,
            borderWidth: 1.5, // 区域边框宽度
            borderColor: '#009fe8', // 区域边框颜色
            areaColor: 'rgba(40, 53, 184, 1)' // 区域颜色
          },
          emphasis: {
            show: false,
            borderWidth: 0.5,
            borderColor: '#4b0082',
            areaColor: '#f47920'
          }
        },
        series: [
          // {
          //   type: 'custom',
          //   coordinateSystem: 'geo',
          //   geoIndex: 0,
          //   zlevel: 1,
          //   data: [
          //     [113.921111, 22.5752222, 100]
          //   ],
          //   renderItem (params, api) {
          //     const coord = api.coord([
          //       api.value(0, params.dataIndex),
          //       api.value(1, params.dataIndex)
          //     ])
          //     const circles = []
          //     for (let i = 0; i < 5; i++) {
          //       circles.push({
          //         type: 'polygon',
          //         shape: {
          //           points: [[5, 0], [10, 5], [5, 10], [0, 5]]
          //         },
          //         style: {
          //           // stroke: 'red',
          //           // fill: 'none',
          //           lineWidth: 2,
          //           shadowColor: 'rgba(0, 0, 0, 0.5)',
          //           shadowBlur: 5
          //         },
          //         // Ripple animation
          //         keyframeAnimation: {
          //           duration: 4000,
          //           loop: true,
          //           // delay: (-i / 4) * 4000,
          //           keyframes: [
          //             {
          //               easing: 'sinusoidalInOut',
          //               percent: 0,
          //               style: {
          //                 opacity: 0.2,
          //                 shadowColor: 'rgba(0, 0, 0, 0.5)',
          //                 shadowBlur: 0
          //               }

          //             },
          //             {
          //               // width: 5,
          //               // height: 5,
          //               easing: 'sinusoidalInOut',
          //               percent: 0.5,
          //               style: {
          //                 opacity: 1,
          //                 shadowColor: 'rgba(0, 0, 0, 1)',
          //                 shadowBlur: 20
          //               }
          //             },
          //             {
          //               // width: 5,
          //               // height: 5,
          //               easing: 'sinusoidalInOut',
          //               percent: 1,
          //               style: {
          //                 opacity: 0.2,
          //                 shadowColor: 'rgba(0, 0, 0, 0.5)',
          //                 shadowBlur: 0
          //               }

          //             }
          //           ]
          //         }
          //       })
          //     }
          //     return {
          //       type: 'group',
          //       x: coord[0],
          //       y: coord[1],
          //       children: [
          //         ...circles
          //         // {
          //         //   type: 'path',
          //         //   shape: {
          //         //     d: 'M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z',
          //         //     x: -10,
          //         //     y: -35,
          //         //     width: 20,
          //         //     height: 40
          //         //   },
          //         //   style: {
          //         //     fill: 'red'
          //         //   },
          //         //   // Jump animation.
          //         //   keyframeAnimation: {
          //         //     duration: 1000,
          //         //     loop: true,
          //         //     delay: Math.random() * 1000,
          //         //     keyframes: [
          //         //       {
          //         //         y: -10,
          //         //         percent: 0.5,
          //         //         easing: 'cubicOut'
          //         //       },
          //         //       {
          //         //         y: 0,
          //         //         percent: 1,
          //         //         easing: 'bounceOut'
          //         //       }
          //         //     ]
          //         //   }
          //         // }
          //       ]
          //     }
          //   }
          // }

          // {
          //   type: 'effectScatter',
          //   coordinateSystem: 'geo',
          //   itemStyle: {
          //     normal: {
          //       borderColor: 'rgba(100,149,237,1)',
          //       borderWidth: 1,
          //       areaStyle: {
          //         color: '#1b1b1b'
          //       }
          //     }
          //   },
          //   data: [],
          //   markPoint: {
          //     symbolSize: 50,
          //     large: true,
          //     effect: {
          //       show: true
          //     },
          //     data: [
          //       {
          //         name: '测试1',
          //         value: 50,
          //         geoCoord: [113.921111, 22.5752222]
          //       },
          //       {
          //         name: '测试2',
          //         value: 50,
          //         geoCoord: [113.941111, 22.5752222]
          //       }
          //     ]
          //   }
          // }
        ]
      },
      mapRightLists: [
        {
          name: '南山街道',
          value: 5293
        },
        {
          name: '西丽街道',
          value: 5020
        },
        {
          name: '蛇口街道',
          value: 2829
        },
        {
          name: '南头街道',
          value: 7718
        },
        {
          name: '粤海街道',
          value: 2029
        },
        {
          name: '沙河街道',
          value: 2912
        },
        {
          name: '招商街道',
          value: 1820
        },
        {
          name: '桃源街道',
          value: 1920
        }
        // {
        //   name: '松岗街道',
        //   value: 1128
        // },
        // {
        //   name: '燕罗街道',
        //   value: 1353
        // }
      ],
      mapLeftLists: [
        {
          name: '花样滑冰（集锦）——北京冬奥会',
          value: 12829
        },
        {
          name: '女子滑雪（集锦）——北京冬奥会',
          value: 11929
        },
        {
          name: '2022年北京冬奥户外宣传短片',
          value: 11291
        },
        {
          name: '开心锤锤',
          value: 10855
        },
        {
          name: '外星人事件',
          value: 12829
        },

        {
          name: '人世间',
          value: 4454
        },
        {
          name: '小品一家人',
          value: 4201
        },
        {
          name: '完美伴侣',
          value: 2551
        },
        {
          name: '宝宝巴士儿歌',
          value: 2518
        },
        {
          name: '小猪佩奇全集',
          value: 2493
        }
      ],
      mapBotLists: [
        {
          name: '户外大屏',
          value: 9
        },
        {
          name: '社区屏',
          value: 267
        },
        {
          name: '家用屏',
          value: 31509
        },
        {
          name: '灯杆屏',
          value: 207
        },
        {
          name: '党建屏',
          value: 30
        }
      ],
      time: null
    }
  },
  computed: {
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    }
  },
  created () {},
  mounted () {
    this.$refs['baoan'].registerMap(nanshanjiedao)
    this.$refs['baoan'].setEchartOption(this.baoanMapOptions)
    this.getTime()
    let v = this
    document.getElementsByClassName('flash-point')[0].addEventListener('click', function (e) {
      let parent = document.getElementsByClassName('flash-point')[0].offsetParent
      // console.log(e)
      // console.log(getComputedStyle(parent))
      v.points.push({
        left: e.x - parent.offsetLeft,
        top: e.y - parent.offsetTop
      })
      // console.log(v.points)
    })
  },
  watch: {},
  methods: {
    getStartsPosition (index) {
      let val = this.points[index]
      if (!val) { return {} }
      let po = {
        left: val.left + 'px',
        top: val.top + 'px'
      }
      // console.log(po)
      return po
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    getTime () {
      this.time = this.$dayjs().format('YYYY年MM月DD日 HH:00')
      this.timeTimeOut = setTimeout(() => {
        this.getTime()
      }, 300000)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeTimeOut)
  }
}
</script>

<style scoped lang="stylus">
@import './stylus/FinancialMediaIntelligent.styl';

.hd {
  text-align: center;
  //background-image: linear-gradient(#0279af, #000405);
  background: url('~@/assets/images/zd-title.png') center center no-repeat
  display: flex;
  justify-content: center;
  height 4.2rem
  margin-bottom 1.5rem
}

h1 {
  color: #74eefc;
  align-self: flex-end;
  font-weight: bold;
  font-size: 1.8rem;
  margin: 2rem 0;
}

.no-scrollbar-y
  >>> .el-scrollbar__wrap
        overflow-x: hidden

.margin-bottom-1rem
  margin-bottom 1rem
</style>
